import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  display: inline-block;
  margin: 0 20px 20px 0;

  ${media.medium`
    order: 3;
    margin: 0 50px 3vw 0;

    &.category {
      order: 1;
    }
  `}
`;
